import { PlainTooltip } from "@similarweb/ui-components";
import { IconButton } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import styled from "styled-components";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";

const StyledInviteUsersButton = styled(IconButton)<{ isNewHomepage?: boolean }>`
    margin-left: ${({ isNewHomepage }) => (isNewHomepage ? "0" : "8px")};
    ${setFontVariant("button", colorsPalettes.carbon[300])};

    ${({ isNewHomepage }) =>
        isNewHomepage &&
        `
        background-color: transparent;
        
        .SWReactIcons svg path {
            fill: ${colorsPalettes.blue[400]};
        }
    
        &:hover,
        &:focus,
        &:active {
            .SWReactIcons svg path {
                fill: ${colorsPalettes.blue[400]};
            }
        }
        `}
`;

export const renderInvitationButtonUI = ({
    onClick,
    tooltipContent,
    isProminent = false,
    isNewHomepage = false,
}: {
    onClick: () => void;
    tooltipContent: string;
    isProminent?: boolean;
    isNewHomepage?: boolean;
}) => {
    const i18n = i18nFilter();

    return isProminent ? (
        <IconButton
            iconName="share-new"
            onClick={onClick}
            type="flat"
        >
            {i18n("growth.homepage.promotionalBanner.InviteButton")}
        </IconButton>
    ) : (
        <PlainTooltip
            tooltipContent={tooltipContent}
            placement="top"
            debounce={200}
        >
            <div style={{ width: "fit-content" }}>
                <StyledInviteUsersButton
                    iconName="share-new"
                    type="flat"
                    isHover={true}
                    iconSize={isNewHomepage ? "xs" : ""}
                    onClick={onClick}
                    isNewHomepage={isNewHomepage}
                />
            </div>
        </PlainTooltip>
    );
};
